<template>
    <div class="">
        <div class="d-flex align-items-center justify-content-between">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item"><router-link to="/dashboard">Dashboard</router-link></li>
                    <li class="breadcrumb-item active" aria-current="page">Sessions</li>
                </ol>
                <label class="form-label"> <h4>Sessions</h4></label>
            </div>
            <div class="d-flex">
                <router-link to="/schools" type="submit" class="btn d-flex align-item-center btn-primary"><i class="ri-list-check me-1"></i>Schools</router-link>
            </div>
        </div>
        <div class="row g-2">
            <div class="col-xl-12 mb-3">
                <div class="card br-16 card-shadow">
                    <div class="card-body">
                        <label class="form-label"> <h4>School Details</h4></label>
                        <div class="row g-2">
                            <div class="col-md-4">
                                <label class="form-label fw-bold">
                                    School Name :
                                </label>
                                <h6>{{session_form_details?.school_name}}</h6>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label fw-bold">
                                    District :
                                </label>
                                <h6>{{session_form_details?.District?.district}}</h6>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label fw-bold">
                                    Place :
                                </label>
                                <h6>{{session_form_details?.place}}</h6>
                            </div>
                            <div class="col-md-2">
                                <a href="javascript:void(0)" class="text-success" data-bs-toggle="modal" data-bs-target="#exampleModal1">
                                    <button style="float: right;" class="btn d-flex align-item-center btn-success">Additional Contact</button>
                                </a>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label fw-bold">
                                    Address :
                                </label>
                                <h6>{{session_form_details?.address}}</h6>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label fw-bold">
                                    Pincode :
                                </label>
                                <h6>{{session_form_details?.pincode}}</h6>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label fw-bold">
                                    Board :
                                </label>
                                <h6>{{session_form_details?.board}}</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4">
                <div class="card br-16 card-shadow">
                    <div class="card-body">
                        <label class="form-label"> <h4 class="">Form</h4></label>
                        <nav class="nav nav-classic">
                            <span v-if="session_forms.length > 0" v-for="(session_form, key) in session_forms" :key="key" class="nav-link text-dark" style="display: flex; justify-content: space-between; align-items: center;">
                                <span style="width: auto;">{{ session_form.display_name }}</span>
                                <span class="badge text-dark fw-bold" style="margin-left: auto; word-break: break-word; overflow-wrap: break-word; font-size: 14px;">
                                    {{ session_form.value }}
                                </span>
                            </span>
                            <span v-else>
                                <span class="badge text-dark" style="word-break: break-word; font-size: 14px;">No additional data is available</span>
                            </span>
                        </nav>
                    </div>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="card br-16 card-shadow">
                    <div class="card-body">
                        <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="form-label mb-0"> <h4 class="mb-0">Comment</h4></label>
                            <div class="">
                                <a type="button" class="btn d-flex align-item-center btn-warning" data-bs-toggle="modal" data-bs-target="#viewCommentHistory" href="javascript:void(0)">Comment History</a>
                            </div>
                        </div>

                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-sm text-nowrap table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th>User</th>
                                        <th>Visited Date</th>
                                        <th>Reminder Date & Time</th>
                                        <th class="text-center">Present Stage</th>
                                        <th class="text-center">Next Stage</th>
                                        <!-- <th class="text-center">History Comment</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="session_comments.length == 0">
                                        <td colspan="6" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="(session_comment, key) in session_comments" :key="key">
                                        <td class="text-center">{{ meta.from + key }}</td>
                                        <td>{{ session_comment?.User?.name || '—' }}</td>
                                        <td>{{ changeDate(session_comment?.date_time) }}</td>
                                        <td>{{ changeDateTime(session_comment?.reminder_date_time) }}</td>
                                        <!-- <td>{{ changeDate(session_comment?.reminder_date_time)}}</td>
                                <td>{{ changeDate(session_comment?.reminder_date_time)}}</td> -->
                                        <td class="text-center">{{ session_comment?.PresentStage?.stage }}</td>
                                        <td class="text-center">{{ session_comment?.NextStage?.stage }}</td>
                                        <!-- <td class="text-center"><a @click.prevent="viewComment(session_comment)" data-bs-toggle="modal" data-bs-target="#viewComment" href="javascript:void(0)" class="text-success me-2" ><i class="ri-eye-line fs-18 lh-1"></i></a></td> -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="mt-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                            <option>10</option>
                            <option>15</option>
                            <option>20</option>
                            <option>25</option>
                            <option>30</option>
                        </select>
                        <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta?.totalRows }} entries</span>
                        <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="viewComment" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Comment</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <h6>{{ session_comment }}</h6>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="viewCommentHistory" tabindex="-1" aria-labelledby="exampleModalLabel2" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel2">Comment History</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <!-- <div class="card mb-3" v-for="(session_comment, key) in session_comments" :key="key">
            <div class="card-body">
                <h5 class="card-title">Visited On  {{ changeDate(session_comment?.date_time) }} </h5>
                <p class="card-text">
                    {{ session_comment?.comment }}
                </p>
            </div>
        </div> -->
                    <div class="card mb-3 card-shadow" v-for="(session_comment, key) in session_comments" :key="key">
                        <h5 class="card-header">Date Visited: {{ changeDate(session_comment?.date_time) }}</h5>
                        <div class="card-body">
                            <div class="row card-title">
                                <div class="col-md-6">
                                    <h6>Comment</h6>
                                </div>
                                <div class="col-md-6">
                                    <h6>Commented By - {{session_comment?.User?.name}}</h6>
                                </div>
                            </div>
                            <p class="card-text">{{ session_comment?.comment }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" data-bs-backdrop="static" id="exampleModal1" tabindex="-1" aria-labelledby="exampleModal1Label" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModal1Label">Additional Contact Details</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeModal"></button>
                </div>
                <div class="modal-body">
                    <div class="table-responsive table-responsive-sm">
                        <table class="table table-sm text-nowrap table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th class="text-center">#</th>
                                    <th>Name</th>
                                    <th>Mobile Number</th>
                                    <th>Email Id</th>
                                    <th>Designation</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="school_contacts.length == 0">
                                    <td colspan="5" class="text-center">No records found</td>
                                </tr>
                                <tr v-for="(school_contact, key) in school_contacts" :key="key">
                                    <td class="text-center">{{ meta.from + key }}</td>
                                    <td>{{ school_contact?.name }}</td>
                                    <td>{{ school_contact?.mobile }}</td>
                                    <td>{{ school_contact?.email}}</td>
                                    <td>{{ school_contact?.designation }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <!-- <button type="button" class="btn btn-primary" @click="submitdistricts()">Save changes</button> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    import moment from "moment";
    export default {
        components: { Pagination },
        data() {
            return {
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "session_comment_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    school_id: "",
                },
                session_comment: "",
                session_forms: [],
                session_comments: [],
                session_form_details: [],
                school_contacts: [],
                errors: [],
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.meta.school_id = to.params.school_id;
                let uri = { uri: "session/sessionFormsDetails", data: { school_id: to.params.school_id } };
                vm.$store
                    .dispatch("post", uri)
                    .then(function (response) {
                        vm.session_forms = response.data.data.session_form_fields;
                        vm.session_form_details = response.data.data.school_details;
                        vm.school_contacts = response.data.data.school_contacts;
                        console.log("vm.session_form", vm.session_form_details);
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            });
        },
        mounted() {
            this.index();
        },

        methods: {
            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },
            changeDate(date_time) {
                return moment(date_time).format("DD-MM-YYYY hh:mm:ss A");
            },
            changeDateTime(date_time) {
                return moment.utc(date_time).format("DD-MM-YYYY hh:mm:ss A");
            },

            index() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "sessionComments/paginateSessionComments", data: vm.meta })
                    .then(function (response) {
                        vm.session_comments = response.data.data.data;
                        vm.meta.totalRows = response.data.data.meta.total;
                        vm.meta.lastPage = response.data.data.meta.lastPage;
                        vm.meta.from = response.data.data.meta.from;
                        const end = vm.meta.from + Number(vm.meta.per_page) - 1;
                        vm.meta.to = end > vm.meta.totalRows ? vm.meta.totalRows : end;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            viewComment(session_comment) {
                console.log("session_comment", session_comment);
                this.session_comment = session_comment.comment;
            },
            // view(session_form) {
            //     this.$router.push("/session_forms/" + session_form.session_form_id + "/view");
            // },
            onPageChange(page) {
                this.meta.page = page;
                this.index();
            },
            sort(field) {
                this.meta.keyword = field;
                this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
                this.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
        },
    };
</script>
